/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Tue Jan 12 2021 10:43:00 GMT+0100 (GMT+01:00)
 */

import { request } from '../utils/request';
import { API_URLS } from '../utils/config';
import moment from 'moment';
import {
  ParServiceResponse,
  ParServiceStep,
  ParCommissionResponse,
  PricingPackResponse,
  PricingResponse,
} from './pricing';
import prepareQueryParams from 'utils/prepareQueryParams';
import { TpAddress } from './thirdParty';
import { ParOffer } from './pricing';
import { FinConElemSpreading } from './fincontract';
const URL = API_URLS.PROPOSAL;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: L[];
  message: string;
}

export interface Asset {
  assetComponents: Array<AssetComponent>;
  assetcategory: string;
  assetconstructor: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetgrossamount: number;
  assetid: number;
  assetlabel: string;
  assetmodel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetorderdate: string;
  assetorderreference: string;
  assetreference: string;
  assetrisklevel: string;
  assetstatus: string;
  assettaxamount: number;
  assettype: string;
  chassisno: string;
  currcode: string;
  deliveryadrcity: string;
  deliveryadrcountry: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  engineno: string;
  fiscaldepreciationmethod: string;
  flagused: boolean;
  plateno: string;
  power: string;
  registrationno: string;
  serialno: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  weight: string;
}

export interface AssetComponent {
  asset: Asset;
  compcategory: string;
  compdescription: string;
  compdiscountamount: number;
  compdiscountrate: number;
  compfree1: string;
  compgrossamount: number;
  compid: number;
  compnetamount: number;
  comporiginalnetamount: number;
  comptaxamount: number;
  comptype: string;
  taxcode: string;
  taxrate: number;
}

export interface AssetComponentResponse {
  assetid: number;
  compcategory: string;
  compdescription: string;
  compdiscountamount: number;
  compdiscountrate: number;
  compfree1: string;
  compgrossamount: number;
  compid: number;
  compnetamount: number;
  comporiginalnetamount: number;
  comptaxamount: number;
  comptype: string;
  taxcode: string;
  taxrate: number;
}

export interface AssetUseRequest {
  id: number;
  assetid: number;
  useid: number;
  condid: number;
  usevaluetype: string;
  usevalue: number;
  usevaluedate: string;
  initmarketvalue: number;
  newmarketvalue: number;
  priidexceed: number;
  usestatus: string;
}
export interface assetUseResponsesRes {
  id: number;
  assetid: number;
  useid: number;
  condid: number;
  usevaluetype: string;
  usevalue: number;
  usevaluedate: string;
  initmarketvalue: number;
  newmarketvalue: number;
  priidexceed: number;
  priidexceedlabel: string;
  usestatus: string;
  attcode: string;
  uselabel: string;
  prcode: string;
  prcodeLabel: string;
  offerid: number;
  offerlabel: string;
  ofrtype: string;
  ofrid: number;
  ofrlabel: string;
  minvalue: number;
  maxvalue: number;
  defaultvalue: number;
  useunittype: string;
  useunittypelabel: string;
  useunitperiod: string;
  useunitperiodlabel: string;
}

export interface IrvScheduleRequest {
  irvid: number;
  irvorder: number;
  startdate: string;
  enddate: string;
  rvpercentage: number;
  irvamount: number;
  finrvamount: number;
  rvgap: number;
  trg: number;
  finrvwithtrg: number;
  rvgapwithtrg: number;
  rentalpart: number;
  interestpart: number;
  capitalpart: number;
  ctstype: string;
}

export interface AssetRequest {
  assetComponents: Array<AssetComponent>;
  assetusereqList: Array<AssetUseRequest>;
  irvSchedule: Array<IrvScheduleRequest>;
  entityAddAttributList?: Array<EntityAdditionalAttributeRequest>;
  assetServiceList: Array<AssetServiceRequest>;

  assetcategory: string;
  assetphase: string;
  assetconstructor: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetgrossamount: number;
  assetid: number;
  assetlabel: string;
  assetmodel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetorderdate: string;
  assetorderreference: string;
  assetreference: string;
  assetrisklevel: string;
  assetstatus: string;
  assettaxamount: number;
  assettype: string;
  chassisno: string;
  currcode: string;
  deliveryadrcity: string;
  deliveryadrcountry: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  engineno: string;
  fiscaldepreciationmethod: string;
  flagused: boolean;
  plateno: string;
  power: string;
  registrationno: string;
  serialno: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  weight: string;
  networkcode: string;
  tpidbroker: number;
  assetfinamount: number;
  degfeesformula: number;
  spfeesformula: number;
  tpofformula: number;
  assetsegment: string;
}

export interface IrvScheduleResponse {
  irvid: number;
  irvorder: number;
  startdate: string;
  enddate: string;
  rvpercentage: number;
  irvamount: number;
  finrvamount: number;
  rvgap: number;
  trg: number;
  finrvwithtrg: number;
  rvgapwithtrg: number;
  accountingdate: string;
  accountingreference: string;
  rentalpart: number;
  interestpart: number;
  capitalpart: number;
  ctstype: string;
}

export interface EntityAdditionalAttributeRequest {
  attbooleanvalue: boolean | null;
  attcode: string;
  attnumericvalue: number;
  attstringvalue: string;
  atttextvalue: string;
  entity: string;
  entityid: number;
  id: number;
}

export interface AssetServiceRequest {
  associd: number;
  assetid?: number;
  catalogid: number;
  servcode: string;
  servfixedamount: number;
  servfixedamountdefault: number;
  servlabel: string;
  servpercentage: number;
  servpercentagedefault: number;
}

export interface ViewEntityAddAttributeResponse {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  attbooleanvalue: boolean;
  attcode: string;
  attcodeparent: string;
  attdatatype: string;
  attinputtype: string;
  attnbrows: number;
  attnumericvalue: number;
  attstringvalue: string;
  atttextvalue: string;
  colspan: number;
  defautvalue: string;
  displayorder: number;
  displayposition: string;
  displaysection: string;
  displaytype: string;
  entity: string;
  entityid: number;
  entitytype: string;
  maxvalue: string;
  minvalue: string;
  parcode: string;
  prcode: string;
  style: string;
}

export interface AssetServiceResponse {
  associd: number;
  assetid?: number;
  catalogid: number;
  servcode: string;
  servfixedamount: number;
  servfixedamountdefault: number;
  servlabel: string;
  servpercentage: number;
  servpercentagedefault: number;
}

export interface AssetUseValuesResponse {
  assetid: number;
  attcode: string;
  creationdate: string;
  flagupdatefv: boolean;
  flagupdatemv: boolean;
  newmarketvalue: number;
  proctaskid: number;
  useid: number;
  useridcreation: number;
  usevalue: number;
  usevaluedate: string;
  valueid: number;
}

export interface AssetUseResponse {
  assetid: number;
  attcode: string;
  condid: number;
  defaultvalue: number;
  id: number;
  initmarketvalue: number;
  lastregistredusedate: string;
  lastregistredusevalue: number;
  maxvalue: number;
  minvalue: number;
  newmarketvalue: number;
  offerid: number;
  offerlabel: string;
  ofrid: number;
  ofrlabel: string;
  ofrtype: string;
  prcode: string;
  prcodeLabel: string;
  priidexceed: number;
  priidexceedLabel: string;
  priidexceedlabel: string;
  useLabel: string;
  useValues: Array<AssetUseValuesResponse>;
  useid: number;
  uselabel: string;
  usestatus: string;
  useunitperiod: string;
  useunitperiodlabel: string;
  useunittype: string;
  useunittypelabel: string;
  usevalue: number;
  usevaluedate: string;
  usevaluetype: string;
}

export interface AssetCatalogComponentResponse {
  assetid: number;
  compcategory: string;
  compcategorylabel: string;
  compdescription: string;
  compdiscountamount: number;
  compdiscountrate: number;
  compfree1: string;
  compgrossamount: number;
  compid: number;
  compnetamount: number;
  comporiginalnetamount: number;
  comptaxamount: number;
  comptype: string;
  comptypelabel: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  suppliername: string;
  supplierreference: string;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
}

export interface ParAssetCatalogServiceResponse {
  associd: number;
  assetid?: number;
  catalogid: number;
  servcode: string;
  servfixedamount: number;
  servfixedamountdefault: number;
  servlabel: string;
  servpercentage: number;
  servpercentagedefault: number;
  servuseunit:string;
  servusefrequency:string;
  servuseunitlabel:string;
  servusefrequencylabel:string;

  servuseqty:number;
  servuseminamount:number;
  servusemaxamount:number;
  servusecoverage:number;
  servusedeductionamount:number;
  servusedeductionpercenrage:number;
  servdescription:string,
  cteid:number;
	startdate:string;
	enddate:string;
	status:string;
}
export interface ParAssetCatalogOptionResponse {
  catalogid: number;
  optcode: string;
  optcodelabel: string;
  optgrossamount: number;
  optid: number;
  optnetamount: number;
  optpictureurl: string;
  optpictureurl2: string;
  optpictureurl3: string;
  optpictureurl4: string;
  optpictureurl5: string;
  optpictureurl6: string;
  opttaxamount: number;
  opttaxcode: string;
  optvalue: string;
  optvaluelabel: string;
  flagfreelabel: boolean;
  flagtopropose: boolean;
  startdate: string;
  enddate: string;
  proposed: boolean;
}

export interface AssetCatalogResponse {
  assetid:number;
  assettaggrouping: string;
  assetCatalogComponents: Array<AssetCatalogComponentResponse>;
  assetCatalogOptions: Array<ParAssetCatalogOptionResponse>;
  assetCatalogServices: Array<ParAssetCatalogServiceResponse>;
  tpidmanufacturer: number;
  manufacturerreference: string;
  manufacturername: string;
  catalogidlinked: number;
  catalogidlinkedlabel: string;
  catalogidorigine: number;
  catalogidoriginelabel: string;
  power: string;
  weight: string;
  assetcategory: string;
  assetcategorylabel: string;
  assetconstructor: string;
  assetconstructorreference: string;
  assetdescription: string;
  assetdiscountamount: number;
  assetdiscountperc: number;
  assetgrossamount: number;
  assetgrossamountorigine: number;
  assetlabel: string;
  assetmodel: string;
  assetmodellabel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetnetamountorigine: number;
  assetpictureurl: string;
  assetpictureurl2: string;
  assetpictureurl3: string;
  assetpictureurl4: string;
  assetpictureurl5: string;
  assetpictureurl6: string;
  assetstatuslabel: string;
  statuslabel?: string;
  assettaxamount: number;
  assetsegment: string;
  assetsegmentlabel: string;
  assettype: string;
  assettypelabel: string;
  assetvariant: string;
  assetversion: string;
  catalogid: number;
  catalogstatus: string;
  enddate: string;
  flagwebshop: boolean;
  mcid: number;
  mclabel: string;
  mgid: number;
  networkcode: string;
  startdate: string;
  suppliername: string;
  taxcode: string;
  taxrate: number;
  tpidbroker: number;
  tpidsupplier: number;
  brokername: string;
  brokerreference: string;
  supplierreference: string;
  currcode: string;
  assetfamilylabel: string;
  assetfamily: string;
  assetclass: string;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
  kwhpower: number;
  kwhproduction: number;
  kwhdegradation: number;
  chassisno?: string;
  assetfinamount: number;
  degfeesformula: number;
  spfeesformula: number;
  tpofformula: number;
  deliverydelay: string;
  age?: number;
  balersize?: string;
  balersizelabel?: string;
  separatortype?: string;
  separatortypelabel?: string;
  wheeldrive?: string;
  wheeldrivelabel?: string;
  transmission?: string;
  transmissionlabel?: string;
  wheeltrack?: string;
  lift?: number;
  capacity?: number;
  tankcapacity?: number;
  nbcampaign?: number;
  threshinghours?: number;
  rotorhours?: number;
  totalhours?: number;
  totalbalers?: number;
  country?: string;
  countrylabel?: string;
  partmethod?: string;
  partamount?: number;
  partrate?: number;
  tpidparticipation?: number;
  participantname?: string;
  participantreference?: string;
  partnbdays?: number;
  rolcode?: string;
  partmethodlabel?: string;
  rolcodelabel?: string;
  id?: number;
  registrationdate?: string;
  registrationcity?: string;
  registrationname?: string;
  firstregistrationdate?: string;
  fiscalpower?: number;
}

export interface AssetResponse {
  assetComponents: Array<AssetComponentResponse>;

  irvSchedule: Array<IrvScheduleResponse>;
  assetusereqList: Array<AssetUseResponse>;
  entityAddAttributList?: Array<ViewEntityAddAttributeResponse>;
  assetServiceList: Array<AssetServiceResponse>;
  assetCatalog: AssetCatalogResponse;
  assetcategory: string;
  assetcategorylabel: string;
  assetconstructor: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetgrossamount: number;
  assetid: number;
  assetlabel: string;
  assetmodel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetorderdate: string;
  assetorderreference: string;
  assetreference: string;
  assetrisklevel: string;
  assetstatus: string;
  assettaxamount: number;
  assettype: string;
  assettypelabel: string;
  chassisno: string;
  currcode: string;
  deliveryadrcity: string;
  deliveryadrcountry: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  engineno: string;
  fiscaldepreciationmethod: string;
  flagused: boolean;
  plateno: string;
  power: string;
  registrationno: string;
  serialno: string;
  statuslabel: string;
  suppliername: string;
  supplierreference: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  weight: string;
  assetqty: number;
  assetqtyavailable?: number;
  cteid: number;
  listrv:any[];
  networkcode: string;
  tpidbroker: number;
  assetfinamount: number;
  degfeesformula: number;
  spfeesformula: number;
  tpofformula: number;

  brokername: string;
  brokerreference: string;
  assetUseResponses: Array<assetUseResponsesRes>;
}

export interface PropStatusResponse {
  phase: string;
  phaselabel: string;
  ctrid: number;
  status: string;
  statusdate: string;
  statuslabel: string;
  id: number;
  updated_at: string;
  userid: number;
  username: string;
}

export interface ShopFinancingRequest {
  assetRequest: Array<ShopAssetRequest>;
  currcode: string;
  last_action: number;
  mgid: number;
  networkcode: string;
  offerid: number;
  prcode: string;
  tpid: number;
  tpidcoborrower: number;
}
export interface ShopAssetOptionRequest {
  optcode: string;
  optid: number;
  optvalue: string;
}
export interface ShopAssetRequest {
  catalogid: number;
  optionsRequest: Array<ShopAssetOptionRequest>;
  pricingElementRequest: Array<PricingElementRequest>;
  spid: number;
}

export interface PricingElementRequest {
  speid: number;
}
export interface Pricing {
  calculationbasis: string;
  calculationmethod: string;
  ctecategory: string;
  ctetype: string;
  deferredinterestmethod: string;
  deferredinterestnominalrate: number;
  depositamount: number;
  depositcoef: number;
  depositinterestmethod: string;
  depositnominalrate: number;
  durationdefault: number;
  durationmax: number;
  durationmin: number;
  durationreqreceiverid: number;
  durationreqreceiverroleprofile: string;
  durationreqreceivertype: string;
  durationreqtype: string;
  enddate: string;
  finamountmax: number;
  finamountmin: number;
  firstrentaldefault: number;
  firstrentalmax: number;
  firstrentalmin: number;
  firstrentalreqreceiverid: number;
  firstrentalreqreceiverroleprofile: string;
  firstrentalreqreceivertype: string;
  firstrentalreqtype: string;
  flagfollowgraceperiod: boolean;
  flagmandatory: boolean;
  flagupdate: boolean;
  gpduration: number;
  gpmethod: string;
  interestmethod: string;
  periodicity: string;
  pridescription: string;
  priid: number;
  prilabel: string;
  pristatus: string;
  rateformula: string;
  rateperiodicity: number;
  ratereqreceiverid: number;
  ratereqreceiverroleprofile: string;
  ratereqreceivertype: string;
  ratereqtype: string;
  ratespreaddefault: number;
  ratespreadmax: number;
  ratespreadmin: number;
  ratetype: string;
  ratevaluedefault: number;
  rvdefault: number;
  rvdefaultamount: number;
  rvmax: number;
  rvmin: number;
  rvreqreceiverid: number;
  rvreqreceiverroleprofile: string;
  rvreqreceivertype: string;
  rvreqtype: string;
  servcalculationmethod: string;
  servfixedamount: number;
  servfixedamountmin: number;
  serviceduration: string;
  servpercentage: number;
  servpercentagemin: number;
  servreqreceiverid: number;
  servreqreceiverroleprofile: string;
  servreqreceivertype: string;
  servreqtype: string;
  startdate: string;
  taxcode: string;
  term: string;
  unit: string;
  upfrontmin: number;
  upfrontmax: number;
  upfrontdefault: number;
}

export interface PropDecisionRequest {
  assetnote: string;
  assetreserve: boolean;
  coborrowernote: string;
  coborrowerreserve: boolean;
  created_at: string;
  created_by: number;
  ctrid: number;
  deccode: string;
  deccomment: string;
  decdate: string;
  decexternalref: string;
  decisionid: number;
  declevel: string;
  decscore: string;
  dectype: string;
  deposit: number;
  depositapproved: number;
  depositreserve: boolean;
  duration: number;
  durationapproved: number;
  durationreserve: boolean;
  finamountapproved: number;
  finamountreserve: boolean;
  firspaymentapproved: number;
  firstpayment: number;
  firstpaymentreserve: boolean;
  guarantornote: string;
  guarantorreserve: boolean;
  insurancenote: string;
  insurancereserve: boolean;
  rate: number;
  rateapproved: number;
  ratereserve: boolean;
  reqfinamount: number;
  residualvalue: number;
  residualvalueapproved: number;
  residualvaluereserve: boolean;
  updated_at: string;
  updated_by: number;
  warrantynote: string;
  warrantyreserve: boolean;
}

export interface PropDecisionResponse {
  assetnote: string;
  assetreserve: boolean;
  coborrowernote: string;
  coborrowerreserve: boolean;
  created_at: string;
  created_by: number;
  username?: string;
  ctrid: number;
  deccode: string;
  deccodelabel: string;
  deccomment: string;
  decdate: string;
  decexternalref: string;
  decisionid: number;
  declevel: string;
  declevellabel: string;
  decscore: string;
  dectype: string;
  deposit: number;
  depositapproved: number;
  depositreserve: boolean;
  duration: number;
  durationapproved: number;
  durationreserve: boolean;
  finamountapproved: number;
  finamountreserve: boolean;
  firspaymentapproved: number;
  firstpayment: number;
  firstpaymentreserve: boolean;
  guarantornote: string;
  guarantorreserve: boolean;
  insurancenote: string;
  insurancereserve: boolean;
  rate: number;
  rateapproved: number;
  ratereserve: boolean;
  reqfinamount: number;
  residualvalue: number;
  residualvalueapproved: number;
  residualvaluereserve: boolean;
  updated_at: string;
  updated_by: number;
  warrantynote: string;
  warrantyreserve: boolean;
}

export interface PropElemAssetRequest {
  assetid: number;
  associd: number;
  cteid: number;
  endate: string;
  finamountin: number;
  finamountout: number;
  fiscalamountin: number;
  fiscalamountout: number;
  free1: string;
  originalamount: number;
  startdate: string;
}

export interface PropElemAssetResponse {
  assetdescription: string;
  assetid: number;
  assetreference: string;
  associd: number;
  cteid: number;
  endate: string;
  finamountin: number;
  finamountout: number;
  fiscalamountin: number;
  fiscalamountout: number;
  free1: string;
  originalamount: number;
  startdate: string;
}

export interface PropElemScheduleRequest {
  ciid: number;
  cilid: number;
  cteid: number;
  ctesid: number;
  ctrid: number;
  ctsactuarialrate: number;
  ctsamortizedamount: number;
  ctsbasisamount: number;
  ctsbasisrate: number;
  ctsdepositbasis: number;
  ctsdepositinterest: number;
  ctsdepositrate: number;
  ctsduedate: string;
  ctsenddate: string;
  ctsid: number;
  ctsinterestamount: number;
  ctsorder: number;
  ctsoutstandingamount: number;
  ctsperiodicity: string;
  ctsrentalamount: number;
  ctsstartamount: number;
  ctsstartdate: string;
  ctsstatus: string;
  ctsterm: string;
  ctstype: string;
  taxcode: string;
}

export interface PropElemScheduleResponse {
  ciid: number;
  cilid: number;
  cteid: number;
  ctesid: number;
  ctrid: number;
  ctsactuarialrate: number;
  ctsamortizedamount: number;
  ctsbasisamount: number;
  ctsbasisrate: number;
  ctsdepositbasis: number;
  ctsdepositinterest: number;
  ctsdepositrate: number;
  ctsduedate: string;
  ctsenddate: string;
  ctsid: number;
  ctsinterestamount: number;
  ctsorder: number;
  ctsoutstandingamount: number;
  ctsperiodicity: string;
  ctsrentalamount: number;
  ctsstartamount: number;
  ctsstartdate: string;
  ctsstatus: string;
  ctsterm: string;
  ctstermlabel: string;
  ctstype: string;
  ctstypelabel: string;
  statuslabel: string;
  taxcode: string;
  taxcodelabel: string;
}

export interface PropElemStepRequest {
  cteid: number;
  ctesamortizedcoef: number;
  ctesduration: number;
  ctesid: number;
  ctesorder: number;
  ctesoutstandingamount: number;
  ctesperiodicity: string;
  ctesperiodicityunit: string;
  ctesrentalamount: number;
  ctesrentalcoef: number;
  ctrid: number;
  status: string;
}

export interface ConElemPrefinStepRequest {
  cteid: number;
  ctrid: number;
  ctesid: number;
  ctesorder: number;
  ctesstartdate: string;
  ctesduration: number;
  ctesperiodicityunit: string;
  ctesperiodicity: string;
  enddate: string;
  calmethod: string;
  rateformula: string;
  ratebasis: string;
  ratespread: number;
  nominalrate: number;
  ctesstartamount: number;
  ctesinterestamount: number;
  ctesamortizedcoef: number;
  ctesamortizedamount: number;
  ctesrentalamount: number;
  ctesoutstandingcoef: number;
  ctesoutstandingamount: number;
}

export interface PropElemPrefinStepResponse {
  cteid: number;
  ctrid: number;
  ctesid: number;
  ctesorder: number;
  ctesstartdate: string;
  ctesduration: number;
  ctesperiodicityunit: string;
  ctesperiodicity: string;
  enddate: string;
  calmethod: string;
  rateformula: string;
  ratebasis: string;
  ratespread: number;
  nominalrate: number;
  ctesstartamount: number;
  ctesinterestamount: number;
  ctesamortizedcoef: number;
  ctesamortizedamount: number;
  ctesrentalamount: number;
  ctesoutstandingcoef: number;
  ctesoutstandingamount: number;
}

export interface PropElemServiceStepRequest {
  ctesid: number;
  steporder: number;
  servcode: string;
  assettype: string;
  assetcategory: string;
  stepunit: string;
  stepduration: number;
  deprpercentage: number;
  servpercentage: number;
  servamount: number;
}

export interface PropElemServiceStepResponse {
  ctesid: number;
  steporder: number;
  servcode: string;
  assettype: string;
  assetcategory: string;
  stepunit: string;
  stepduration: number;
  deprpercentage: number;
  servpercentage: number;
  servamount: number;
}

export interface PropElemStepResponse {
  cteid: number;
  ctesamortizedcoef: number;
  ctesduration: number;
  ctesid: number;
  ctesorder: number;
  ctesyear: number;
  ctesyearend: number;
  ctesoutstandingamount: number;
  ctesperiodicity: string;
  ctesperiodicityunit: string;
  ctesperiodicityunitlabel: string;
  ctesrentalamount: number;
  ctesrentalcoef: number;
  ctrid: number;
  status: string;
}

export interface PropElemAttributeResponse {
  cteattid: number;
  cteid: number;
  attid: number;
  atttype: string;
  atttypelabel: string;
  tpid: number;
  tpname: string;
  tpreference: string;
  tprole: string;
  attcode: string;
  attcodelabel: string;
  attdirection: string;
  attmethod: string;
  attmethodlabel: string;
  attexternalreference: string;
  attamount: number;
  attamountmax: number;
  attamountmin: number;
  attcoefmin: number;
  attcoefmax: number;
  attamountmethod: string;
  attamountmethodlabel: string;
  attcoef: number;
  attrate: number;
  attnbdays: number;
  flagaddmanual: boolean;
  flagupdate: boolean;
  flagdelete: boolean;
  requesttype: string;
  requestreceivertype: string;
  requestreceiverroleprofile: string;
  requestreceiverid: number;
  proccode: string;
  taskid: number;
  proctaskid: number;
  tasklabel: string;
  attstatus: string;
  attstatuslabel: string;
  nbmonthsmax: number;
  nbmonthsdefault: number;
  flagaddauto: boolean;
  attcomment: string;
  attamountrequested: number;
  attamountagreed: number;
  nbmonthsrequested: number;
  attlabel: string;
}

export interface PropElemAttributeRequest {
  cteattid: number;
  cteid: number;
  attid: number;
  atttype: string;
  tpid: number;
  tprole: string;
  attcode: string;
  attdirection: string;
  attmethod: string;
  attexternalreference: string;
  attamount: number;
  attamountmethod: string;
  attcoef: number;
  attrate: number;
  attnbdays: number;
  flagaddmanual: boolean;
  flagupdate: boolean;
  flagdelete: boolean;
  requesttype: string;
  requestreceivertype: string;
  requestreceiverroleprofile: string;
  requestreceiverid: number;
  proccode: string;
  taskid: number;
  proctaskid: number;
  attstatus: string;
  nbmonthsmax: number;
  nbmonthsdefault: number;
  flagaddauto: boolean;
  attcomment: string;
  attamountrequested: number;
  attamountagreed: number;
  nbmonthsrequested: number;
  attlabel: string;
}

export interface ParPricingStep {
  ctesamortizedcoef: number;
  ctesduration: number;
  ctesid: number;
  ctesorder: number;
  ctesoutstandingamount: number;
  ctesperiodicity: string;
  ctesrentalamount: number;
  ctesrentalcoef: number;
  ctesperiodicityunit: string;
  priid: number;
}

export interface PropElementRequest {
  conElemAttributes: Array<PropElemAttributeRequest>;
  offer: PricingPackResponse;
  depositratetype: string;
  deferredinterestratetype: string;
  ofrid: number;
  ofrlabel: string;
  ofrtype: string;
  servfixedamount: number;
  servpercentage: number;
  servbasis: number;
  rvcalculationmode: string;
  rvevaluationmode: string;
  prefinrateref: number;
  prefinratespread: number;
  cterateref: number;
  taxrate: number;
  taxtype: string;
  assetid: number;
  pritype: string;
  conElemAssets: Array<PropElemAssetRequest>;
  conElemSchedules: Array<PropElemScheduleRequest>;
  conElemSteps: Array<PropElemStepRequest>;
  conElemServiceSteps: Array<PropElemServiceStepRequest>;
  serviceResponse: ParServiceResponse;
  serviceStepList: Array<ParServiceStep>;
  pricingStepList: Array<ParPricingStep>;
  commissionResponse: ParCommissionResponse;
  ctebilligdate: string;
  calculatedamountbasis: string;
  marginoncalulatedcamount: number;
  additionalcostaftermargin: number;
  cteactuarialrate: number;
  ctecalculationbasis: string;
  ctecalculationtype: string;
  ctecategory: string;
  ctecategorylabel: string;
  ctedeferredinterest: number;
  ctedeferredinterestmethod: string;
  ctedeferredinterestnominalrate: number;
  ctedepositamount: number;
  ctedepositcoef: number;
  ctedepositinterest: number;
  ctedepositinterestmethod: string;
  ctedepositnominalrate: number;
  ctedescription: string;
  ctedirection: string;
  cteduration: number;
  cteendamount: number;
  cteenddate: moment.MomentInput;
  ctefinancedamount: number;
  ctefirstpayment: number;
  ctefirstpaymentcoef: number;
  ctefirstpaymentdate: string;
  ctefree1: string;
  ctegraceperiodduration: number;
  ctegraceperiodmethod: string;
  cteid: number;
  cteidparent: number;
  cteinitialamount: number;
  cteinstallmentamount: number;
  cteinterestmethod: string;
  cteinvestamount: number;
  ctenominalrate: number;
  cteorder: number;
  ctepartamount: number;
  ctepartdays: number;
  ctepartmethod: string;
  ctepartrate: number;
  ctepaymentterm: string;
  cteperiodicity: string;
  cteratebasis: string;
  cterateformula: string;
  cterateperiodicity: string;
  cteratespread: number;
  cterateterm: string;
  cteratetype: string;
  cterentalamount: number;
  ctervamount: number;
  ctervcoef: number;
  ctestartamount: number;
  ctestartdate: moment.MomentInput;
  ctestatus: string;
  ctetype: string;
  cteunit: string;
  cteupfrontamount: number;
  ctrid: number;
  currcode: string;
  ctemileage: number;
  ctepriidexceed: number;
  last_action: string;
  prefinbasis: string;
  prefinmethod: string;
  prefinnominalrate: number;
  prefinperiodicity: string;
  prefinrateformula: string;
  prefinratetype: string;
  priid: number;
  taxcode: string;
  tpid: number;
  tpidparticipation: any;
  helpers: {
    servfixedamountmin: number;
    servpercentagemin: number;
    servcontextmin: number;
    durationmax: number;
    durationmin: number;
    marginratemin: number;
    marginratemax: number;
    margincontextmin: number;
    margincontextmax: number;
    frmin: number;
    frmax: number;
    gpmin: number;
    gpmax: number;
    upmin: number;
    upmax: number;
    rvmax: number;
    rvmin: number;
    rvcontextmax: number;
    rvcontextmin: number;
    gpdurationmax: number;
    ratemax: number;
    ratemin: number;
    ratecontextmax?: number;
    ratecontextmin?: number;
    frcontextmax?: number;
    frcontextmin?: number;
    durationcontextmax?: number;
    durationcontextmin?: number;
    partnbdaysmax?: number;
  };
  pricing: Pricing;
  spvassetdiscount: number;
  spvriskrate: number;
  spvadditionalfees: number;
  spvloancoef: number;
  spvdiscountsale: number;
  spvinflation: number;
  spvassetdiscountamount: number;
  spvloanamount: number;
  spvriskamount: number;
  spvfeesamount: number;
  rvauthid: number;
  rvtaskid: number;
  rateauthid: number;
  ratetaskid: number;
  frauthid: number;
  frtaskid: number;
  durationauthid: number;
  durationtaskid: number;
  servtaskid: number;
  servauthid: number;
  margintaskid: number;
  marginauthid: number;
  ctefeesamount: number;
  ctecommissionamount: number;
  cteprofitabilityrate: number;
  cteaprrate: number;
  cteflatrate: number;
  ctecoefrate: number;
  ctefundingrate: number;
  ctefundingperiodicity: number;
  ctefundinginstallment: number;
  ctefundingcost: number;
  ctemarginamount: number;
  ctemarginrate: number;
  ctevatdeferralamount: number;
  ctevatdeferralduration: number;
  ctevatdeferralmethod: string;
  ctevatdeferraldaysbasis: string;
  cteextracosttofinance: number;
  cteextracostcomment: string;
  totalInterest: number;
  totalRental: number;
  totalAmortization: number;
  totaldiscountedInterest: number;
  totalVatDeffered: number;
  totaldiscountedOutstanding: number;
  totaldiscountedAgiosdeb: number;
  totalAgiosdeb: number;
  marginImpactCredit: number;
  marginImpactDebit: number;
  dgo: number;
  profitabilityAmount: number;
  conElemPrefinSteps?: Array<ConElemPrefinStepRequest>;
  ceilingrate: number;
  ceilingdefaultrate: number;
  floorrate: number;
  floordefaultrate: number;
  calid: number;
  ctepartratetype?: string;
  ctepartrateformula?: string;
  ctepartinvoicingmode?: string;
  ctepartratespread?: number;
  ctepartratedefault?: number;
  servtype?: string;
  servuseunit:string;
servusefrequency:string;
servuseqty:number;
servuseminamount:number;
servusemaxamount:number;
servusecoverage:number;
servusedeductionamount:number;
servusedeductionpercenrage:number;
servdescription:string,

}

export interface PropElementResponse {
  ofrid: number;
  ofrlabel: string;
  ofrtype: string;
  servfixedamount: number;
  servpercentage: number;
  servbasis: number;
  rvcalculationmode: string;
  rvevaluationmode: string;
  prefinrateref: number;
  prefinratespread: number;
  cterateref: number;
  conElemIFRS: Array<FinConElemSpreading>;
  conElemSpreading: Array<FinConElemSpreading>;
  assetdescription: string;
  serviceResponse: ParServiceResponse;
  commissionResponse: ParCommissionResponse;
  serviceStepList: Array<ParServiceStep>;
  pricingStepList: Array<ParPricingStep>;
  conElemPrefinSteps: Array<PropElemPrefinStepResponse>;
  taxrate: number;
  taxtype: string;
  assetid: number;
  assetreference: string;
  conElemAssets: Array<PropElemAssetResponse>;
  conElemSchedules: Array<PropElemScheduleResponse>;
  fundingSchedule: Array<PropElemScheduleResponse>;
  conElemSteps: Array<PropElemStepResponse>;
  conElemAttributes: Array<PropElemAttributeResponse>;
  cteactuarialrate: number;
  ctebilligdate: string;
  ctecalculationbasis: string;
  ctecalculationbasislabel: string;
  ctecalculationtype: string;
  ctecalculationtypelabel: string;
  ctecategory: string;
  ctecategorylabel: string;
  ctedeferredinterest: number;
  ctedeferredinterestmethod: string;
  ctedeferredinterestmethodlabel: string;
  ctedeferredinterestnominalrate: number;
  ctedepositamount: number;
  ctedepositcoef: number;
  ctedepositinterest: number;
  ctedepositinterestmethod: string;
  ctedepositinterestmethodlabel: string;
  ctedepositnominalrate: number;
  ctedescription: string;
  ctedirection: string;
  ctedirectionlabel: string;
  cteduration: number;
  cteendamount: number;
  cteenddate: string;
  ctefinancedamount: number;
  ctefirstpayment: number;
  ctefirstpaymentcoef: number;
  ctefirstpaymentdate: string;
  ctefree1: string;
  ctegraceperiodduration: number;
  ctegraceperiodmethod: string;
  ctegraceperiodmethodlabel: string;
  cteid: number;
  cteidparent: number;
  cteidparentorder: number;
  cteinitialamount: number;
  cteinstallmentamount: number;
  cteinterestmethod: string;
  cteinvestamount: number;
  ctenominalrate: number;
  cteorder: number;
  ctepartamount: number;
  ctepartdays: number;
  ctepartmethod: string;
  ctepartmethodlabel: string;
  ctepartrate: number;
  ctepaymentterm: string;
  ctepaymenttermlabel: string;
  cteperiodicity: string;
  cteperiodicitylabel: string;
  cteratebasis: string;
  cterateformula: string;
  cterateperiodicity: string;
  cteratespread: number;
  cterateterm: string;
  cteratetype: string;
  cterentalamount: number;
  ctervamount: number;
  ctervcoef: number;
  ctestartamount: number;
  ctestartdate: string;
  ctestatus: string;
  ctestatuslabel: string;
  ctetype: string;
  ctetypelabel: string;
  cteunit: string;
  cteunitlabel: string;
  cteupfrontamount: number;
  ctrid: number;
  currcode: string;
  ctemileage: number;
  ctepriidexceed : number;
  last_action: string;
  prefinbasis: string;
  prefinmethod: string;
  prefinnominalrate: number;
  prefinperiodicity: string;
  prefinrateformula: string;
  prefinratetype: string;
  pricing: PricingResponse;
  priid: number;
  prilabel: string;
  taxcode: string;
  tpid: number;
  tpidparticipation: any;
  tpnameparticipation?: any;
  tpreferenceparticipation?: any;
  tpname: string;
  tpnamepart: string;
  marginratemin: number;
  marginratemax: number;
  margincontextmin: number;
  margincontextmax: number;

  rvauthid: number;
  rvtaskid: number;
  rateauthid: number;
  ratetaskid: number;
  frauthid: number;
  frtaskid: number;
  durationauthid: number;
  durationtaskid: number;
  servtaskid: number;
  servauthid: number;
  margintaskid: number;
  marginauthid: number;
  ctefeesamount: number;
  ctecommissionamount: number;
  cteprofitabilityrate: number;
  cteaprrate: number;
  cteflatrate: number;
  ctecoefrate: number;
  ctefundingrate: number;
  ctefundingperiodicity: number;
  ctefundinginstallment: number;
  ctefundingcost: number;
  ctemarginamount: number;
  ctemarginrate: number;
  ctevatdeferralamount: number;
  ctevatdeferralduration: number;
  ctevatdeferralmethod: string;
  ctevatdeferraldaysbasis: string;
  cteextracosttofinance: number;
  cteextracostcomment: string;
  totalInterest: number;
  totalRental: number;
  totalAmortization: number;
  totaldiscountedInterest: number;
  totalVatDeffered: number;
  totaldiscountedOutstanding: number;
  totaldiscountedAgiosdeb: number;
  totalAgiosdeb: number;
  marginImpactCredit: number;
  marginImpactDebit: number;
  dgo: number;
  profitabilityAmount: number;
  spvassetdiscount: number;
  spvriskrate: number;
  spvadditionalfees: number;
  spvloancoef: number;
  spvdiscountsale: number;
  spvinflation: number;
  spvassetdiscountamount: number;
  spvloanamount: number;
  spvriskamount: number;
  spvfeesamount: number;
  payid?: number;
  payidreimbursment?: number;
  payrefrence?: string;
  payreimbreference?: string;
  ceilingrate: number;
  ceilingdefaultrate: number;
  floorrate: number;
  floordefaultrate: number;
  calid: number;
  ctepartratetype?: string;
  ctepartrateformula?: string;
  ctepartinvoicingmode?: string;
  ctepartratespread?: number;
  ctepartratedefault?: number;
  servuseunit:string;
servusefrequency:string;
servuseqty:number;
servuseminamount:number;
servusemaxamount:number;
servusecoverage:number;
servusedeductionamount:number;
servusedeductionpercenrage:number;
servdescription:string,

}

export interface ProposalListResponse {
  brid: number;
  brokername: string;
  clientname: string;
  ctactivationdate: string;
  ctdeliverydate: string;
  ctdescription: string;
  ctfinancedamount: number;
  ctnetworkcode: string;
  ctorderdate: string;
  ctphase: string;
  ctreference: string;
  ctrid: number;
  ctstage: string;
  ctstatus: string;
  ctstatusdate: string;
  mcid: number;
  mgid: number;
  offerid: number;
  offeridlabel: string;
  prcode: string;
  prcodelabel: string;
  propreference: string;
  statuslabel: string;
  tpidbroker: number;
  tpidclient: number;
  tprefbroker: string;
  tpreference: string;
  mfid: number;
  mfreference: string;
  currcode: string;
  cteduration: number;
  cteupfrontamount: number;
  ctervamount: number;
  ctefirstpayment: number;
  cterentalamount: number;
  ctepartamount: number;
  ctegraceperiodduration: number;
  ctedescription: string;
  assetpictureurl: string;
  catalogid: number;
  ctremainingduration: number;
  totalnotinvoicedrental: number;
  totalnotinvoicedservice: number;
  totalunpaidamount: number;
  totaloutstandingamount: number;
  ctnetworkcodelabel: string;
  ctcomment?: string;
}
export interface Syndicationlist {
  partamount: number;
  ctrid: number;
  partcoef: number;
  partnername: string;
  partnerreference: string;
  payinmode: string;
  payoutmode: string;
  syndid: number;
  tpadrid: number;
  tpbkidin: number;
  tpbkidout: number;
  tpid: number;
  tprole: string;
}
export interface TpBankAccount {
  countcode: string;
  bkaccountkey: string;
  bkaccountnum: string;
  bkcode: string;
  bkbranchcode: string;
  bkenddate: string;
  bkstartdate: string;
  bkstatus: string;
  bkstatusdate: string;
  bktype: string;
  currcode: string;
  tpbankname: string;
  tpbic: string;
  tpbkid: number;
  tpcbdate: string;
  tpcbkey: string;
  tpcbname: string;
  tpcbnum: string;
  tpcbtype: string;
  tpiban: string;
  tpid: number;
}
export interface PropThirdPartyResponse {
  address: TpAddress;
  bankAccountIn: TpBankAccount;
  bankAccountOut: TpBankAccount;
  ctrid: number;
  enddate: string;
  mfagreedamount: number;
  mfavailableamount: number;
  mfbookedamount: number;
  mfrequestedamount: number;
  mfusedamount: number;
  mfvaliditydate: string;
  startdate: string;
  status: string;
  statusdate: string;
  tpadrid: number;
  tpbkidin: number;
  tpbkidout: number;
  tpblocklateinterestinvoicing: boolean;
  tpblockrejectionfeesinvoicing: boolean;
  tpblockreminderfeesinvoicing: boolean;
  tpid: number;
  tplateinterestformula: string;
  tpname: string;
  tppaydelayin: string;
  tppaydelayout: string;
  tppaymodein: string;
  tppaymodeout: string;
  tpreference: string;
  tprejectionfeesformula: string;
  tpreminderfeesformula: string;
  tprolecode: string;
  tproleid: number;
}
export interface ProposalRequest {
  assets: Array<AssetRequest>;
  brid: number;
  conElements: Array<PropElementRequest>;
  ctacceptancedate: string;
  ctactivationdate: string;
  ctbankname: string;
  ctbic: string;
  ctbillingdate: string;
  ctbouserdate: string;
  ctbouserid: number;
  ctcbdate: string;
  ctcbkey: string;
  ctcbname: string;
  ctcbnum: string;
  ctcbtype: string;
  ctdeliverydate: string;
  ctdescription: string;
  ctenddate: string;
  ctfinancedamount: number;
  ctflagreminder: boolean;
  ctfree1: string;
  ctfree2: string;
  ctfree3: string;
  ctfree4: string;
  ctiban: string;
  ctidautorization: number;
  ctinitenddate: string;
  ctinitstartdate: string;
  ctinvoiceaddresscity: string;
  ctinvoiceaddressname: string;
  ctinvoiceaddressstr1: string;
  ctinvoiceaddressstr2: string;
  ctinvoiceaddresszipcode: string;
  ctinvoicesendingmode: string;
  ctinvoicingmode: string;
  ctlateinterestformula: string;
  ctlpuserdate: string;
  ctlpuserid: number;
  ctnetworkcode: string;
  ctorderdate: string;
  ctpartialpayoffformula: string;
  ctpaymentdelay: number;
  ctpaymentmode: string;
  ctphase: string;
  ctrecuserdate: string;
  ctrecuserid: number;
  ctreference: string;
  ctrequestdate: string;
  ctrid: number;
  ctriskstatus: string;
  ctriskstatusdate: string;
  ctriskuserdate: string;
  ctriskuserid: number;
  ctsaleuserdate: string;
  ctsaleuserid: number;
  ctstage: string;
  ctstatus: string;
  ctstatusdate: string;
  cttotalpayoffformula: string;
  cttype: string;
  currcode: string;
  last_action: string;
  mcid: number;
  mgid: number;
  offerid: number;
  prcode: string;
  priid: number;
  pritype: string;
  propreference: string;
  tpidbroker: number;
  tpidclient: number;
  tpidcoborrower: number;
  tpidguarantor: number;
  tpidsupplier: number;
  tpinvoiceaddressregion: string;
  ctfirstpaymentmode: string;
  ctdeliverymode: string;
  tpiddelivery: number;
  ctvaliditydate: string;
  ctfclevel: string;
  syndication: Array<Syndicationlist>;
  tpidsyndlead: number;
  ctsyndinvoicingtype: string;
  ctsyndsuppliermanagementtype: string;
  ctsyndpaymentmanagementtype: string;
  ctsyndmgcoef: number;
  ctsyndmgpartamount: number;
  thirdParties: Array<PropThirdPartyRequest>;
  mfagreedamount: number;
  mfavailableamount: number;
  mfbookedamount: number;
  mfflagrevolving: boolean;
  mfrequestedamount: number;
  mfusedamount: number;
  mfvaliditydate: string;
}
export interface PropThirdPartyRequest {
  tpname: string;
  ctrid: number;
  enddate: string;
  mfagreedamount: number;
  mfavailableamount: number;
  mfbookedamount: number;
  mfrequestedamount: number;
  mfusedamount: number;
  mfvaliditydate: string;
  startdate: string;
  status: string;
  statusdate: string;
  tpadrid: number;
  tpbkidin: number;
  tpbkidout: number;
  tpblocklateinterestinvoicing: boolean;
  tpblockrejectionfeesinvoicing: boolean;
  tpblockreminderfeesinvoicing: boolean;
  tpid: number;
  tplateinterestformula: string;
  tppaydelayin: string;
  tppaydelayout: string;
  tppaymodein: string;
  tppaymodeout: string;
  tprejectionfeesformula: string;
  tpreminderfeesformula: string;
  tprolecode: string;
  tproleid: number;
  tprolecodelabel: string;
  isNew: boolean;
}

export interface tpAdditionalInfoResponse {
  tpdescription: string;
  tpfree1: string;
  tpfree2: string;
  tpfree3: string;
  tpfree4: string;
  tpfree5: string;
  tpparentcompanyid: number;
  tpparentcompanyname: string;
}

export interface tpAddressResponse {
  tpmainadrcity: string;
  tpmainadrcountry: string;
  tpmainadrregion: string;
  tpmainadrstreet1: string;
  tpmainadrstreet2: string;
  tpmainadrzipcode: string;
  tpsecadrcity: string;
  tpsecadrcountry: string;
  tpsecadrregion: string;
  tpsecadrstreet1: string;
  tpsecadrstreet2: string;
  tpsecadrzipcode: string;
}

export interface tpBankAccountResponse {
  tpbankname: string;
  tpbic: string;
  tpcbdate: string;
  tpcbkey: string;
  tpcbname: string;
  tpcbnum: string;
  tpcbtype: string;
  tpiban: string;
}

export interface tpContactResponse {
  tpcontactname1: string;
  tpcontactname2: string;
  tpcontactposition1: string;
  tpcontactposition2: string;
  tpemail1: string;
  tpemail2: string;
  tptel1: string;
  tptel2: string;
  tptelmobile1: string;
  tptelmobile2: string;
}

export interface tpCorrespondentResponse {
  tpbouserdate: string;
  tpbouserid: number;
  tpbousername: string;
  tplpuserdate: string;
  tplpuserid: number;
  tplpusername: string;
  tprecuserdate: string;
  tprecuserid: number;
  tprecusername: string;
  tpriskuserdate: string;
  tpriskuserid: number;
  tpriskusername: string;
  tpsaleuserdate: string;
  tpsaleuserid: number;
  tpsaleusername: string;
}

export interface tpGeneralDataResponse {
  countcode: string;
  lancode: string;
  mgid: number;
  tpactivity: string;
  tpbirthcity: string;
  tpbirthcountry: string;
  tpbirthdate: string;
  tpbranchid: number;
  tpcompanycreationdate: string;
  tpfiscalcity: string;
  tpfiscalid: string;
  tpgender: string;
  tpid: number;
  tpidentitycardid: string;
  tpidentitycardtype: string;
  tplegalform: string;
  tpmaidenname: string;
  tpmanagername: string;
  tpmanagerposition: string;
  tpmaritalstatus: string;
  tpmarketingname: string;
  tpmiddlename: string;
  tpname: string;
  tpnbofchildren: number;
  tpprofession: string;
  tpreference: string;
  tpsalutationcode: string;
  tpstatus: string;
  tpstatusdate: string;
  tpsurname: string;
  tptaxid: string;
  tptype: string;
  tpworkingctdate: string;
  tpworkingcttype: string;
}

export interface tpIncomeResponse {
  tpemloyertel: string;
  tpemployer: string;
  tpemployeraddress: string;
  tpfamilybenefits: number;
  tpmonthlyincome: number;
  tpotherloan: number;
  tpothersexpense: number;
  tpothersincome: number;
}

export interface tpRoleResponse {
  tpflagclient: boolean;
  tpflagguarantor: boolean;
  tpflagsupplier: boolean;
  tppaydelayin: string;
  tppaydelayout: string;
  tppaymodein: string;
  tppaymodeout: string;
  tproleother: string;
}

export interface tpSpouseResponse {
  spbirthcity: string;
  spbirthcountry: string;
  spbirthdate: string;
  spemloyertel: string;
  spemployer: string;
  spemployeraddress: string;
  spfiscalid: string;
  spgender: string;
  spidentitycardid: string;
  spidentitycardtype: string;
  spmaidenname: string;
  spmonthlyincome: number;
  spname: string;
  spotherloan: number;
  spothersexpense: number;
  spothersincome: number;
  spprofession: string;
  spsalutationcode: string;
  spsurname: string;
}

export interface tpStatusResponse {
  tpriskstatus: string;
  tpriskstatusdate: string;
  tpsalestatus: string;
  tpsalestatusdate: string;
}
export interface PropSyndicationResponse {
  ctrid: number;
  partcoef: number;
  partnername: string;
  partnerreference: string;
  payinmode: string;
  payoutmode: string;
  syndid: number;
  tpbkidin: number;
  tpbkidout: number;
  tpadrid: number;
  tpid: number;
  tprole: string;
}
export interface ThirdPartyResponse {
  additionalInfo: tpAdditionalInfoResponse;
  address: tpAddressResponse;
  bankAccount: tpBankAccountResponse;
  contact: tpContactResponse;
  correspondent: tpCorrespondentResponse;
  generalData: tpGeneralDataResponse;
  income: tpIncomeResponse;
  role: tpRoleResponse;
  spouse: tpSpouseResponse;
  status: tpStatusResponse;
}
export interface ProposalResponse {
  assets: Array<AssetResponse>;
  ctreversalreasonlabel: string;
  catalogid: number;
  assetpictureurl: string;
  ctcomment: string;
  ctstartdateinit: string;
  ctenddateinit: string;
  ctdurationmonths: number;
  branchname: string;
  branchreference: string;
  brid: number;
  brokername: string;
  brokerreference: string;
  clientData: ThirdPartyResponse;
  clientname: string;
  clientreference: string;
  cobname: string;
  cobreference: string;
  conElements: Array<PropElementResponse>;
  ctacceptancedate: string;
  ctsignaturedate: string;
  ctactivationdate: string;
  ctbankname: string;
  ctbic: string;
  ctbillingdate: string;
  ctbouserdate: string;
  ctbouserid: number;
  ctcbdate: string;
  ctcbkey: string;
  ctcbname: string;
  ctcbnum: string;
  ctcbtype: string;
  ctdecisioncode: string;
  ctdecisioncodelabel: string;
  ctdecisioncomment: string;
  ctdecisiondate: string;
  ctdecisionlevel: string;
  ctdecisionlevellabel: string;
  ctdecisiontype: string;
  ctdegradationfeesformula: string;
  ctdeliverydate: string;
  ctdeliverymode: string;
  ctdescription: string;
  ctenddate: string;
  ctfclevel: string;
  ctfinancedamount: number;
  ctfirstpaymentmode: string;
  ctflagreminder: boolean;
  ctfree1: string;
  ctfree2: string;
  ctfree3: string;
  ctfree4: string;
  ctiban: string;
  ctidautorization: number;
  ctinitenddate: string;
  ctinitstartdate: string;
  ctinvoiceaddresscity: string;
  ctinvoiceaddresscitylabel: string;
  ctinvoiceaddressname: string;
  ctinvoiceaddressstr1: string;
  ctinvoiceaddressstr2: string;
  ctinvoiceaddresszipcode: string;
  ctinvoicesendingmode: string;
  ctinvoicingmode: string;
  ctlateinterestformula: string;
  ctlpuserdate: string;
  ctlpuserid: number;
  ctmodificationfeesformula: string;
  ctnetworkcode: string;
  ctorderdate: string;
  ctpartialpayoffformula: string;
  ctpaymentdelay: string;
  ctpaymentmode: string;
  ctphase: string;
  ctphaselabel: string;
  ctrecuserdate: string;
  ctrecuserid: number;
  ctreference: string;
  ctrequestdate: string;
  ctreversalreason: string;
  ctrid: number;
  ctriskstatus: string;
  ctriskstatusdate: string;
  ctriskuserdate: string;
  ctriskuserid: number;
  ctsaleuserdate: string;
  ctsaleuserid: number;
  ctstage: string;
  ctstatus: string;
  ctstatusdate: string;
  ctstatuslabel: string;
  ctsyndinvoicingtype: string;
  ctsyndpaymentmanagementtype: string;
  ctsyndsuppliermanagementtype: string;
  ctsyndmgcoef: number;
  ctsyndmgpartamount: number;
  cttotalpayoffformula: string;
  cttype: string;
  ctvaliditydate: string;
  currcode: string;
  flagasset: boolean;
  flagfleet: boolean;
  flagmasterfacility: boolean;
  flagrealestate: boolean;
  guarantorname: string;
  guarantorreference: string;
  last_action: number;
  mcid: number;
  mfagreedamount: number;
  mfavailableamount: number;
  mfbookedamount: number;
  mfflagrevolving: boolean;
  mfprcode: string;
  mfrequestedamount: number;
  mfusedamount: number;
  mfvaliditydate: string;
  mgid: number;
  offer: ParOffer;
  offerid: number;
  offerlabel: string;
  prcode: string;
  priid: number;
  prilabel: string;
  pritype: string;
  propreference: string;
  suppliername: string;
  supplierreference: string;
  syndication: Array<PropSyndicationResponse>;
  syndleadname: string;
  syndleadreference: string;
  thirdParties: Array<PropThirdPartyResponse>;
  tpadrid: number;
  tpbkidin: number;
  tpbkidout: number;
  tpdeliveryname: string;
  tpdeliveryreference: string;
  tpidbroker: number;
  tpidclient: number;
  tpidcoborrower: number;
  tpiddelivery: number;
  tpidguarantor: number;
  tpidsupplier: number;
  tpidsyndlead: number;
  tpinvoiceaddressregion: string;
  tpmail: string;

  ctendofterm: string;
  ctendoftermtaskid: number;
  ctendoftermdelay: string;
  ctchannelcode: string;
  vendorid: any;
  flaguseassetgrossamount: boolean;
  flagretailer: boolean;
}

export interface ProposalTPResponse {
  tpid: number;
  tpname: string;
  tpreference: string;
  tprole: string;
}
export interface SplitAssetResponse {
  assetid: number;
}

export interface ProposalUsedAmountResponse {
  commission: number;
  ctrid: number;
  depositused: number;
  disbursment: number;
  finamountused: number;
  firsrentalused: number;
  partused: number;
  rentalamountused: number;
  rvamountused: number;
  upfrontused: number;
}

export interface FindCTByAnyRefOrStatusOrDateParams {
  clientname: string;
  ctreference: string;
  ctstatus: string;
  datemax: string;
  datemin: string;
  mfid?: number;
  prcode: string;
  tpreference: string;
  tpidclient?: number;
}

/**
 * @tags Proposal Controller
 * @summary findCTByAnyRefOrStatusOrDate
 */
export function findCTByAnyRefOrStatusOrDate(
  params: FindCTByAnyRefOrStatusOrDateParams
) {
  return request.get<AbstractResponse<object, ProposalListResponse>>(
    `${URL}/api/contract` +
      prepareQueryParams({
        clientname: params.clientname,
        ctreference: params.ctreference,
        ctstatus: params.ctstatus,
        datemax: params.datemax,
        datemin: params.datemin,
        mfid: params.mfid,
        prcode: params.prcode,
        tpreference: params.tpreference,
        tpidclient: params.tpidclient,
      } as any)
  );
}

export interface FindPropByAnyRefOrStatusOrDateParams {
  tpauthid?: number;
  tpauthdetailid?: number;
  branchid: number;
  brokername: string;
  clientname: string;
  ctphase: string;
  ctstatus: string;
  datemax: string;
  datemin: string;
  marketingid: number;
  mfid?: number;
  network: string;
  offerid: number;
  prcode: string;
  propreference: string;
  tpidbroker?: number;
  tprefbroker: string;
  tpreference: string;
  ctreference: string;
  tpidclient?: number;
  flagPropWithCtreference?: boolean;
}

/**
 * @tags Proposal Controller
 * @summary findPropByAnyRefOrStatusOrDate
 */
export function findPropByAnyRefOrStatusOrDate(
  params: FindPropByAnyRefOrStatusOrDateParams
) {
  return request.get<AbstractResponse<object, ProposalListResponse>>(
    `${URL}/api/proposal` +
      prepareQueryParams({
        branchid: params.branchid,
        brokername: params.brokername,
        clientname: params.clientname,
        ctphase: params.ctphase,
        ctstatus: params.ctstatus,
        datemax: params.datemax,
        datemin: params.datemin,
        marketingid: params.marketingid,
        mfid: params.mfid,
        network: params.network,
        offerid: params.offerid,
        prcode: params.prcode,
        propreference: params.propreference,
        ctreference: params.ctreference,
        tpidbroker: params.tpidbroker,
        tprefbroker: params.tprefbroker,
        tpreference: params.tpreference,
        tpauthid: params.tpauthid,
        tpauthdetailid: params.tpauthdetailid,
        flagPropWithCtreference: params.flagPropWithCtreference,
        tpidclient: params.tpidclient,
      } as any)
  );
}

export interface CreateProposalParams {
  ctRequest: ProposalRequest;
}

/**
 * @tags Proposal Controller
 * @summary createProposal
 */
export function createProposal(params: CreateProposalParams) {
  return request.post<AbstractResponse<ProposalResponse, object>>(
    `${URL}/api/proposal`,
    params.ctRequest
  );
}

export interface InsertDecisionParams {
  decRequest: PropDecisionRequest;
}

/**
 * @tags Proposal Controller
 * @summary insertDecision
 */
export function insertDecision(params: InsertDecisionParams) {
  return request.post<AbstractResponse<PropDecisionResponse, object>>(
    `${URL}/api/proposal/decision`,
    params.decRequest
  );
}

export interface GetDecisionByIdParams {
  decisionid: number;
}

/**
 * @tags Proposal Controller
 * @summary getDecisionById
 */
export function getDecisionById(params: GetDecisionByIdParams) {
  return request.get<AbstractResponse<PropDecisionResponse, object>>(
    `${URL}/api/proposal/decision/${params.decisionid}`
  );
}

export interface UpdateDecisionParams {
  decRequest: PropDecisionRequest;
  decisionid: number;
}

/**
 * @tags Proposal Controller
 * @summary updateDecision
 */
export function updateDecision(params: UpdateDecisionParams) {
  return request.put<AbstractResponse<PropDecisionResponse, object>>(
    `${URL}/api/proposal/decision/${params.decisionid}`,
    params.decRequest
  );
}

export interface GetDecisionListByCtridParams {
  ctrid: number;
}

/**
 * @tags Proposal Controller
 * @summary getDecisionListByCtrid
 */
export function getDecisionListByCtrid(params: GetDecisionListByCtridParams) {
  return request.get<AbstractResponse<object, PropDecisionResponse>>(
    `${URL}/api/proposal/decisionList/${params.ctrid}`
  );
}

export interface GenerateContractReferenceParams {
  ctphase: string;
  ctrid: number;
  ctstage: string;
  ctstatus: string;
}

/**
 * @tags Proposal Controller
 * @summary generateContractReference
 */
export function generateContractReference(
  params: GenerateContractReferenceParams
) {
  return request.put<AbstractResponse<ProposalResponse, object>>(
    `${URL}/api/proposal/setContractReference` +
      prepareQueryParams({
        ctphase: params.ctphase,
        ctrid: params.ctrid,
        ctstage: params.ctstage,
        ctstatus: params.ctstatus,
      } as any)
  );
}

export interface UpdateContractStatusParams {
  ctphase: string;
  ctrid: number;
  ctstage: string;
  ctstatus: string;
}

/**
 * @tags Proposal Controller
 * @summary updateContractStatus
 */
export function updateContractStatus(params: UpdateContractStatusParams) {
  return request.put<AbstractResponse<ProposalResponse, object>>(
    `${URL}/api/proposal/status` +
      prepareQueryParams({
        ctphase: params.ctphase,
        ctrid: params.ctrid,
        ctstage: params.ctstage,
        ctstatus: params.ctstatus,
      } as any)
  );
}

export interface GetProposalThirdPartyParams {
  ctrid: number;
  role: string;
}

/**
 * @tags Proposal Controller
 * @summary getProposalThirdParty
 */
export function getProposalThirdParty(params: GetProposalThirdPartyParams) {
  return request.get<AbstractResponse<object, ProposalTPResponse>>(
    `${URL}/api/proposal/thirdparty` +
      prepareQueryParams({ ctrid: params.ctrid, role: params.role } as any)
  );
}

export interface GetProposalUsedAmountsParams {
  ctrid: number;
}

/**
 * @tags Proposal Controller
 * @summary getProposalUsedAmounts
 */
export function getProposalUsedAmounts(params: GetProposalUsedAmountsParams) {
  return request.get<AbstractResponse<ProposalUsedAmountResponse, object>>(
    `${URL}/api/proposal/usedAmounts/${params.ctrid}`
  );
}

export interface GetProposalByIdParams {
  ctrid: number;
}

/**
 * @tags Proposal Controller
 * @summary getProposalById
 */
export function getProposalById(params: GetProposalByIdParams) {
  return request.get<AbstractResponse<ProposalResponse, object>>(
    `${URL}/api/proposal/${params.ctrid}`
  );
}

export interface UpdateProposalParams {
  ctRequest: ProposalRequest;
  ctrid: number;
}

/**
 * @tags Proposal Controller
 * @summary updateProposal
 */
export function updateProposal(params: UpdateProposalParams) {
  return request.put<AbstractResponse<ProposalResponse, object>>(
    `${URL}/api/proposal/${params.ctrid}`,
    params.ctRequest
  );
}

export interface CreateShopProposalParams {
  request: ShopFinancingRequest;
}

/**
 * @tags Proposal Controller
 * @summary createShopProposal
 */
export function createShopProposal(params: CreateShopProposalParams) {
  return request.post<AbstractResponse<ProposalResponse, object>>(
    `${URL}/api/shop/proposal`,
    params.request
  );
}
export interface SplitAssetParams {
  assetid: number;
  ctrid: number;
  qty: number;
}
/**
 * @tags Proposal Controller
 * @summary splitAsset
 */
export function splitAsset(params: SplitAssetParams) {
  return request.put<AbstractResponse<object, SplitAssetResponse>>(
    `${URL}/api/proposal/splitAsset` +
      prepareQueryParams({
        assetid: params.assetid,
        ctrid: params.ctrid,
        qty: params.qty,
      } as any)
  );
}

export interface GetPropStatusHistoryParams {
  ctrid: number;
}

/**
 * @tags Proposal Controller
 * @summary getPropStatusHistory
 */
export function getPropStatusHistory(params: GetPropStatusHistoryParams) {
  return request.get<AbstractResponse<object, PropStatusResponse>>(
    `${URL}/api/proposal/statusHistory/${params.ctrid}`
  );
}

/**
 * @tags Proposal Controller
 * @summary version
 */
export function version() {
  return request.get<string>(`${URL}/api/version`);
}

export interface UpdateProposalThirdPartyParams {
  request: PropThirdPartyRequest;
  tproleid: number;
}
/**
 * @tags Proposal Controller
 * @summary updateProposalThirdParty
 */
export function updateProposalThirdParty(
  params: UpdateProposalThirdPartyParams
) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/proposal/thirdparty/${params.tproleid}`,
    params.request
  );
}

export interface UpdateProposalThirdPartyStatusParams {
  tproleid: number;
  status: string;
}

/**
 *  @tags Proposal Controller
 * @summary updateProposalThirdPartyStatus
 */
export function updateProposalThirdPartyStatus(
  params: UpdateProposalThirdPartyStatusParams
) {
  return request.put<AbstractResponse<PaymentResponse, object>>(
    `${URL}/api/proposal/thirdparty/${params.tproleid}/${params.status}`
  );
}

export interface removeProposalThirdPartyParams {
  tproleid: number;
  removeGuar: boolean;
}

/**
 *  @tags Proposal Controller
 * @summary removeProposalThirdParty
 */
export function removeProposalThirdParty(
  params: removeProposalThirdPartyParams
) {
  return request.delete<AbstractResponse<PaymentResponse, object>>(
    `${URL}/api/proposal/thirdparty/${params.tproleid}` +
      prepareQueryParams({
        removeGuar: params.removeGuar,
      } as any)
  );
}
